export default "__VITE_PUBLIC_ASSET__d1c6b4ff__"